export const CREATE_SEMANTIC_MODEL_CLASS_PROFILE = "create-class-profile";
export function isCreateSemanticModelClassProfile(operation) {
    return operation.type === CREATE_SEMANTIC_MODEL_CLASS_PROFILE;
}
export const MODIFY_SEMANTIC_MODEL_CLASS_PROFILE = "modify-class-profile";
export function isModifySemanticModelClassProfile(operation) {
    return operation.type === MODIFY_SEMANTIC_MODEL_CLASS_PROFILE;
}
export const CREATE_SEMANTIC_MODEL_RELATIONSHIP_PROFILE = "create-relation-profile";
export function isCreateSemanticModelRelationshipProfile(operation) {
    return operation.type === CREATE_SEMANTIC_MODEL_RELATIONSHIP_PROFILE;
}
export const MODIFY_SEMANTIC_MODEL_RELATIONSHIP_PROFILE = "modify-relation-profile";
export function isModifySemanticModelRelationshipProfile(operation) {
    return operation.type === MODIFY_SEMANTIC_MODEL_RELATIONSHIP_PROFILE;
}
//# sourceMappingURL=operations.js.map